import React, { useState, useEffect, useMemo } from 'react';
import axiosInstance from './backend/axiosInstance';
import { motion } from "framer-motion";
import { data, Link } from 'react-router-dom';
import { LeagueIcons, LeaugeIconsInvert } from './data/LeagueIcons';
import { TeamIconComponent } from './data/TeamIcons';
import { AgentIcons } from './data/AgentIcons';
import { Maps } from './data/MapIcons';
import { useParams } from 'react-router-dom';
import "./Match.css";

const Header = ({ data }) => {
    const team1Stats = data.team_performances.find(
        t => t.teamName === data.team1
    );

    const team2Stats = data.team_performances.find(
        t => t.teamName === data.team2
    );

    return (
        <div className="match-header">
            <div className="header-top">

                <div className="team-block left">
                    <div className="score">{data.team1Score}</div>
                    <TeamIconComponent team={data.team1} />
                    <div className="team-info">
                        <div className="team-name">{data.team1}</div>

                        <div className="team-name" style={{ display: 'flex' }}>
                            <div className='atk'>
                                {team1Stats?.attackRoundsWon ?? 0}
                            </div>
                            /
                            <div className='def'>
                                {team1Stats?.defenseRoundsWon ?? 0}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="center-block">
                    <div className="map-name">{data.map}</div>
                    <div className="match-time">{data.time}</div>
                </div>

                <div className="team-block right">
                    <div className="team-info">
                        <div className="team-name">{data.team2}</div>
                        <div className="team-name" style={{ display: 'flex' }}>
                            <div className='atk'>
                                {team2Stats?.attackRoundsWon ?? 0}
                            </div>
                            /
                            <div className='def'>
                                {team2Stats?.defenseRoundsWon ?? 0}
                            </div>

                        </div>
                    </div>
                    <TeamIconComponent team={data.team2} />
                    <div className="score">{data.team2Score}</div>
                </div>

            </div>
        </div>
    );
};


const getRoundIcon = (cause) => {
    switch (cause) {
        case "ELIMINATION":
            return "⚔️";
        case "SPIKE_DEFUSE":
            return "🛡️";
        case "DETONATE":
            return "💣";
        case "TIME_EXPIRED":
            return "⏱️";
        default:
            return "•";
    }
};

const RoundTimeline = ({ rounds, team1, team2 }) => {

    const maxRound = Math.max(...rounds.map(r => r.roundNumber));

    const roundMap = useMemo(() => {
        const map = {};
        rounds.forEach(r => {
            map[r.roundNumber] = r;
        });
        return map;
    }, [rounds]);

    const rows = [];
    for (let start = 1; start <= maxRound; start += 24) {
        rows.push(Array.from({ length: 24 }, (_, i) => start + i));
    }

    const getBgClass = (round, team) => {
        if (!round) return "empty";

        if (round.winningTeamTag !== team) return "lose";

        const isAtkWin = round.winningTeamTag === round.attackingTeamTag;
        return isAtkWin ? "atk-win" : "def-win";
    };

    const renderCell = (roundNum, team) => {
        const round = roundMap[roundNum];

        return (
            <div className={`round-cell ${getBgClass(round, team)}`}>
                {round && round.winningTeamTag === team
                    ? getRoundIcon(round.cause)
                    : ""
                }
            </div>
        );
    };

    return (
        <div className="match-header">

            {rows.map((row, rowIndex) => (
                <div key={rowIndex} className="round-block">

                    {/* HEADER NUMBERS */}
                    <div className="round-grid-row">
                        <div className="team-spacer" />

                        {row.map((num, i) => (
                            <React.Fragment key={num}>
                                {i === 12 && <div className="round-gap" />}
                                <div className="round-number">
                                    {num <= maxRound ? num : ""}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>

                    {/* TEAM 1 */}
                    <div className="round-grid-row">
                        <div className="team-label">
                            <TeamIconComponent team={team1} />
                            {team1}
                        </div>

                        {row.map((roundNum, i) => (
                            <React.Fragment key={roundNum}>
                                {i === 12 && <div className="round-gap" />}
                                {renderCell(roundNum, team1)}
                            </React.Fragment>
                        ))}
                    </div>

                    {/* TEAM 2 */}
                    <div className="round-grid-row">
                        <div className="team-label">
                            <TeamIconComponent team={team2} />
                            {team2}
                        </div>

                        {row.map((roundNum, i) => (
                            <React.Fragment key={roundNum}>
                                {i === 12 && <div className="round-gap" />}
                                {renderCell(roundNum, team2)}
                            </React.Fragment>
                        ))}
                    </div>

                </div>
            ))}

        </div>
    );
};

const MatchComponent = () => {
    const { gameId } = useParams();
    const [matchData, setMatchData] = useState(null);


    useEffect(() => {
        axiosInstance.get('matches/' + gameId + "/")
            .then((response) => {
                setMatchData(response.data);
                document.title = response.data["team1"] + "-" + response.data["team2"];


            })

    }, [gameId]);


    if (!matchData) {
        return <div>Loading...</div>;
    }


    return (
        <div style={{ display: 'flex', flexDirection: "column", alignItems: "center" }}>
            <Header data={matchData} />
            <RoundTimeline
                rounds={matchData.rounds}
                team1={matchData.team1}
                team2={matchData.team2}
            />
            <div style={{ width: "100%", padding: "10px", color: 'white' }}>

                {matchData.team1}
                AAAAAAAAAA
            </div>
        </div>

    );
}



export default MatchComponent;
